import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DateTimeFormatter, dateFormat } from '../../../common/formatter/DateTimeFormatter';
import { IDisolveDetail, IReportEntry } from '../../../generated/ApiClient';
import { formatToEuro } from '../../deals/new/finances/FinancesCalculationList';
import { getValueWithVatCoefficientApplied } from './OverlayDissolveValues.utils';

const surchargeRelative = 0.025;

interface Props {
  dissolve?: IDisolveDetail;
  report?: IReportEntry;
  isMboeCar: boolean | undefined;
  vatCoefficient: number;
}

export function OverlaySurcharge({ report, dissolve, isMboeCar, vatCoefficient }: Props) {
  const { t } = useTranslation();

  const listPrice = report?.listPrice ?? 0;
  const surcharge = listPrice * surchargeRelative;
  const dissolveValue = dissolve?.dissolveValue ?? 0;
  const showSurcharge = !!report?.listPrice && isMboeCar;
  const showHint = !!dissolve?.dissolveValue;

  if (!showSurcharge) return null;

  return (
    <Grid item container xs={12} mb={12} width="100%" rowSpacing={2}>
      <Grid item xs={3} className="value-column">
        <div>{t('dashboard.contractsOverlay.dissolveValues.surcharge')}</div>
      </Grid>
      <Grid item xs={3} className="value-column">
        <div>{formatToEuro(getValueWithVatCoefficientApplied(surcharge, vatCoefficient))}</div>
      </Grid>
      <Grid item xs={12}>
        <Typography>{t('dashboard.contractsOverlay.dissolveValues.surchargeHint')}</Typography>
      </Grid>
      {showHint && (
        <Grid item xs={12}>
          <Typography>
            {t('dashboard.contractsOverlay.dissolveValues.surchargeExample', {
              date: DateTimeFormatter.format(dissolve?.dueDate, { format: dateFormat }),
              surcharge: formatToEuro(getValueWithVatCoefficientApplied(surcharge, vatCoefficient)),
              dissolveValue: formatToEuro(
                getValueWithVatCoefficientApplied(dissolveValue, vatCoefficient)
              ),
              sum: formatToEuro(
                getValueWithVatCoefficientApplied(dissolveValue + surcharge, vatCoefficient)
              ),
            })}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}
